import { DevicesFiltersType } from '@components/device/DevicesFilter'
import { makeFilter, makeSearchFilter } from './crud/filters'


export const prepareDeviceFilter = (filters: DevicesFiltersType) => {
  const idsFilter = makeFilter('id', 'eq', filters.id)
  const uuidFilter = makeFilter('uuid', 'contains', filters.uuid)
  const hardwareIdFilter = makeFilter('device_hardware_id', 'contains', filters.hardwareId)
  const nameFilter = makeSearchFilter('device_name', 'includes', filters.name)
  const typeFilter = makeFilter('device_type', 'contains', filters.type)
  const modelFilter = makeFilter('device_model', 'contains', filters.model)
  const osFilter = makeFilter('device_os', 'contains', filters.os)
  const osVersionFilter = makeFilter('device_os_version', 'contains', filters.osVersion)
  const appVersionFilter = makeFilter('device_app_version', 'contains', filters.appVersion)
  const shopIdFilter = makeFilter('shop_id', 'contains', filters.shopId)

  return {
    and: [
      idsFilter,
      uuidFilter,
      hardwareIdFilter,
      nameFilter,
      typeFilter,
      modelFilter,
      osFilter,
      osVersionFilter,
      appVersionFilter,
      shopIdFilter
    ]
  }
}